import { ComposerPrimitive, useAuiState } from '@assistant-ui/react';
import { faPaperPlane } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type FC } from 'react';
import './Composer.scss';

export const Composer: FC = () => {
  const isRunning = useAuiState(({ thread }) => thread.isRunning);
  return (
    <ComposerPrimitive.Root className={'chat-composer'}>
      <div className={'field is-grouped'}>
        <div className={`control is-expanded ${isRunning ? 'is-loading' : ''}`}>
          <ComposerPrimitive.Input
            className={'textarea is-soft'}
            readOnly={isRunning}
            placeholder={'Write a message…'}
            rows={1}
            autoFocus
          />
        </div>
        <div className={'control'}>
          <ComposerPrimitive.Send className={`button is-medium ${isRunning ? 'is-loading' : ''}`} disabled={isRunning}>
            <i className={'icon'}>
              <FontAwesomeIcon icon={faPaperPlane} />
            </i>
          </ComposerPrimitive.Send>
        </div>
      </div>
    </ComposerPrimitive.Root>
  );
};
Composer.displayName = 'Composer';
